import React from 'react';
export const FounderQuoteSection = () => {
  return <section className="bg-gradient-to-b from-teal-800 to-teal-700 text-white py-16" data-id="element-157">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-158">
        <div className="bg-white bg-opacity-10 p-8 rounded-lg shadow-lg" data-id="element-159">
          <div className="flex flex-col md:flex-row items-center md:items-start gap-6" data-id="element-160">
            <div className="w-40 h-40 flex-shrink-0" data-id="element-161">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6Eqs1XSQYf14N4eupNhVa2/a72d7f-b65f-f3f-db31-1bd8fccf7dda_b5678e5b-b47a-449f-a3a7-7890b1473025_%282%29.webp" alt="Dr. Kim DiRe'" className="w-full h-full object-cover rounded-full shadow-md" data-id="element-162" />
            </div>
            <div data-id="element-163">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-164">
                A Note From Our Founder, Dr. Kim DiRe'
              </h2>
              <blockquote className="text-lg italic" data-id="element-165">
                "I created Neurotoned because so many of my clients already
                understood trauma—but didn't have the tools to heal it. This
                program distills over 20 years of clinical experience in somatic
                therapy into one daily, structured path that actually works."
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>;
};